/** Resolve http(s) URL for OWASP ZAP gateway scans. */
export function resolveWebScanUrl(
  details?: Record<string, unknown> | null,
  targetHint?: string | null,
): string | null {
  const d = details || {}
  const candidates = [
    d.url,
    d.URL,
    d.website,
    targetHint,
  ]
  for (const raw of candidates) {
    const s = String(raw ?? '').trim()
    if (!s) continue
    if (/^https?:\/\//i.test(s)) return s
    if (/^[a-z0-9][-a-z0-9.]*\.[a-z]{2,}/i.test(s) && !/^\d+\.\d+\.\d+\.\d+$/.test(s)) {
      return `https://${s}`
    }
  }
  return null
}
